import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { BackLink } from '@bibliocommons/base-links';

import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from 'app/components/shared/FullScreenOverlay';
import FormattedHTMLMessage from 'app/components/shared/FormattedHTMLMessage';
import { FACET_FILTER_UI_TYPE } from 'app/constants/FacetsConstants';
import { facetFilterShape, fieldIdShape } from 'app/shapes/facets';
import Filter from '../Filter';

import './ShowMoreOverlay.scss';

export default function ShowMoreOverlay({ fieldId, filters, handleToggleFilter, handleAllFilters, subCategory }) {
  function renderFilters(filter) {
    return (
      <Filter
        fieldId={fieldId}
        filter={filter}
        filterUiType={FACET_FILTER_UI_TYPE.CHECKBOXES}
        handleToggleFilter={handleToggleFilter}
        key={`filter-${fieldId}-${filter.get('value')}`}
        subCategory={subCategory}
      />
    );
  }

  return (
    <fieldset className="cp-show-more-overlay">
      <FullScreenOverlayBody>
        <FullScreenOverlayHeader
          className="title"
          title={<FormattedHTMLMessage id={`all_${fieldId.toLowerCase()}`} />}
        />
        <FullScreenOverlayContent size="small">
          {handleAllFilters && (
            <BackLink
              className="all-filters-link"
              dataKey="all-filters-link"
              href="#all-filters"
              preventDefault
              handleClick={handleAllFilters}
            >
              <span aria-hidden>
                <FormattedMessage id="all_filters" />
              </span>
              <ScreenReaderMessage>
                <FormattedMessage id="sr_all_filters" />
              </ScreenReaderMessage>
            </BackLink>
          )}
          <div className="show-more-content">
            <ul className="filter-list">{filters.map(renderFilters)}</ul>
          </div>
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    </fieldset>
  );
}

ShowMoreOverlay.propTypes = {
  fieldId: fieldIdShape.isRequired,
  filters: ImmutablePropTypes.listOf(facetFilterShape).isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  handleAllFilters: PropTypes.func,
  subCategory: ImmutablePropTypes.map
};
